import Vue from 'vue';

const EventBus = new Vue({
  name: 'EventBus',
});

Vue.set(Vue.prototype, '$bus', EventBus);

export default EventBus;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/lib/plugins/bus.js